<app-header [logoImg]="logoImg" [enableStickyHeader]="false"></app-header>
<app-revolution-slider-db></app-revolution-slider-db>
<!-- <app-help></app-help> -->
<app-our-clients *ngIf="!page.includes('cloud-it-department')" [pricingLink]="pricingLink"></app-our-clients>
<app-products *ngIf="page.includes('cloud-it-department')"></app-products>
<app-databases *ngIf="!page.includes('cloud-it-department')"></app-databases>
<app-footer></app-footer>
